import React, { useState } from "react";
import DashboardLayout from "../Layout/DashboardLayout";
import Breadcrumbs from "../Components/Dashboard/Breadcrumbs";
import { ReactComponent as SearchIcon } from "../Assets/Icons/search.svg";
import FilterICon from "../Assets/Icons/filterIcon.svg";
import InfoIcon from "../Assets/Icons/info.svg";
import AITeamCard from "../Components/AITeamCard";
import TeamImg from "../Assets/TeamImg.png";
import TeamImgOne from "../Assets/TeamImg1.png";
import TeamImgTwo from "../Assets/TeamImg2.png";
import TeamImgThree from "../Assets/TeamImg3.png";
import CloseIcon from "../Assets/Icons/crossIcon.svg";
import AiTeamDropDown from "../Components/AiTeamDropDown";

export function MyAiTeam() {
  const [openFilter, setOpenFilter] = useState(false);
  return (
    <DashboardLayout>
      <section className="bg-white pl-6 py-4 gap-y-5 w-full flex flex-col items-start">
        <Breadcrumbs links={[{ name: "Search Teams", link: "dsads" }]} />
        <h1 className="text-xl font-semibold">All AI Teams</h1>
        <div className="flex items-center gap-4">
          <div className="flex items-center ">
            <div className="rounded-l-lg border flex items-center py-2 px-3 bg-[#F9FAFB] w-[23rem]">
              <SearchIcon />
              <input
                type="text"
                placeholder="Search Teams"
                className="border-none ml-2 bg-inherit w-full text-sm font-medium text-[#6B7280] focus:outline-none"
              />
            </div>
            <div>
              <button className="w-[4.4rem] py-2 px-2 text-[0.95rem] font-[500] text-white rounded-r-lg bg-[#942A27]">
                Search
              </button>
            </div>
          </div>
          <div className="relative">
            <button
              className="w-[5.6rem] h-[2.3rem] flex items-center justify-center border-[1px] border-[#E5E7EB] rounded-[8px] gap-2"
              onClick={() => setOpenFilter(!openFilter)}
            >
              <img src={FilterICon} /> Filters
            </button>
            {openFilter && (
              <div
                style={{
                  boxShadow:
                    "0px 10px 10px 0px rgba(0, 0, 0, 0.04), 0px 20px 25px -5px rgba(0, 0, 0, 0.10)",
                }}
                className="w-[43rem] pt-6 pb-6 border-[1px] border-[#E5E7EB] rounded-[8px] px-6 absolute bg-white z-50 top-10"
              >
                <div className="flex items-center justify-between">
                  <p className="[1.1rem] text-[#6B7280]">Filter</p>
                  <img
                    className="cursor-pointer"
                    src={CloseIcon}
                    onClick={() => setOpenFilter(false)}
                  />
                </div>
                <div>
                  <div className="flex items-center flex-wrap gap-3 mt-3">
                    <AiTeamDropDown
                      text="Availability Status"
                      width="40rem"
                      options={["now", "other"]}
                    />
                    <AiTeamDropDown
                      text="Frameworks"
                      width="12.80rem"
                      options={[
                        "Amazon Machine Learning",
                        "AutoCAD",
                        "C#",
                        "Databricks",
                        "Keras",
                        "Matlab",
                        "Spark",
                        "TensorFlow",
                        "Microsoft Cognitive Toolkit",
                        "SQL",
                        "R",
                        "Scikit Learn",
                        "PyTorch",
                        "Tableau",
                        "Other",
                      ]}
                    />
                    <AiTeamDropDown
                      text="Front End"
                      width="12.80rem"
                      options={[
                        "Angular",
                        "Bootstrap",
                        "CSS",
                        "HTML",
                        "JavaScript",
                        "Material UI",
                        "React",
                        "Vue",
                        "Webpack",
                        "Other",
                      ]}
                    />
                    <AiTeamDropDown
                      text="Back End"
                      width="12.80rem"
                      options={[
                        "ASP.NET",
                        "Java",
                        "Node",
                        "Python",
                        "Ruby on Rails",
                        "Other",
                      ]}
                    />
                    <AiTeamDropDown
                      text="Database"
                      width="12.80rem"
                      options={[
                        "ArangoDb",
                        "Cassandra",
                        "CouchDB",
                        "ElasticSearch",
                        "Kafka",
                        "Microsoft SQL Server",
                        "MongoDB",
                        "MySQL",
                        "Neo4j",
                        "Oracle",
                        "PostgreSQL",
                        "Redis",
                        "SQS",
                        "ZeroMQ",
                        "Other",
                      ]}
                    />
                    <AiTeamDropDown
                      text="DevOps"
                      width="12.80rem"
                      options={[
                        "AWS",
                        "Azure",
                        "Ansible",
                        "BladeCenter",
                        "Chef",
                        "Docker",
                        "ELK",
                        "Jenkins",
                        "Kubernetes",
                        "NGINX",
                        "VMware",
                        "Other",
                      ]}
                    />
                    <AiTeamDropDown
                      text="Mobile App"
                      width="12.80rem"
                      options={[
                        "Ionic",
                        "Java",
                        "Kotlin",
                        "Objective-C",
                        "PWA",
                        "React Native",
                        "SDQ",
                        "Swift",
                        "Xamarin",
                        "Other",
                      ]}
                    />
                    <AiTeamDropDown
                      text="Data Science Toolkits"
                      width="12.80rem"
                      options={[
                        "NumPy",
                        "Matplotlib",
                        "NLTK",
                        "Scikit-learn",
                        "Pandas",
                        "SciPy",
                        "Other",
                      ]}
                    />
                    <AiTeamDropDown
                      text="Cloud Vendor Experience"
                      width="12.80rem"
                      options={[
                        "DataRobot",
                        "IBM Watson",
                        "Looker",
                        "Sas",
                        "Alteryx",
                        "Amazon SageMaker",
                        "DataBricks",
                        "Google Cloud",
                        "Looker",
                        "Machine Learning",
                        "Microsoft Azure Cognitive Services",
                        "Other",
                      ]}
                    />
                    <AiTeamDropDown
                      text="Foundational Models"
                      width="12.80rem"
                      options={[
                        "GPT-4",
                        "Falcon",
                        "GPT-3",
                        "Bert",
                        "GPT-2",
                        "GPT-Neo",
                        "GPT-J",
                        "Megatron-Turing NLG",
                        "Ernie 3.0 Titan",
                        "Claude",
                        "GLAM( Generalist Language Model)",
                        "Gopher",
                        "LaMDA ( Language Models for Dialog Application)",
                        "GPT-NeoX",
                        "Chinchilla",
                        "PaLM ( Pathway Language Model)",
                        "OPT (Open Pretrained Transformer)",
                        "YaLM 100B",
                        "Minerva",
                        "BLOOM",
                        "Alexa ™ (Teacher Models)",
                        "LLaMa ( Large Language Model Meta AI)",
                        "Cerebras GPT",
                        "Other"
                      ]}
                    />
                    <AiTeamDropDown
                      text="Based on Role"
                      width="12.80rem"
                      options={[
                        "Ideation",
                        "Exploration",
                        "Development",
                        "Deployment",
                        "Explorium",
                        "Full Stack",
                        "Back End",
                        "AI/ML",
                        "MLOps",
                        "DevOps",
                        "Front End",
                        "Mobile",
                        "Other",
                      ]}
                    />
                    <AiTeamDropDown
                      text="Deep Understanding"
                      width="12.80rem"
                      options={[
                        "Compex Code Basis",
                        "Large Systems",
                        "Data Mining",
                        "Predictive Modeling",
                        "Algorithms",
                        "Large Systems",
                        "Data Structures",
                        "Machine Learning Libraries",
                        "Artificial Neural Networks",
                        "Version Control System",
                        "Pattern Recognition",
                        "Recommendation Systems",
                        "Deep Learning Frameworks",
                        "Computer Science Fundamentals",
                        "Other",
                      ]}
                    />
                    <AiTeamDropDown
                      text="Technology & Tools"
                      width="12.80rem"
                      options={[
                        "Big Data and Cloud",
                        "Blockchain Technology",
                        "Business Intelligence and Visualization",
                        "CRM",
                        "ERP",
                        "Accounting",
                        "Operations",
                        "Marketing Automation",
                        "Chatbot and Voice Assistant",
                        "Data analysis and AI Tools",
                        "Data analysis in Biology",
                        "Data Science",
                        "Data Warehouse Appliance",
                        "Design and Animation",
                        "DevOps Tools",
                        "Deep Learning",
                        "Enterprise Information Archiving",
                        "Enterprise Performance Management",
                        "In-Memory Appliances",
                        "Machine Learning Framework",
                        "Mapping and GIS",
                        "Master Data Management",
                        "Programming Languages and Framework",
                        "QA Tools",
                        "Reinforcement Learning",
                        "Robotics Process Automation (RPA)",
                        "Security Analytics",
                        "Web Analytics Platform",
                        "Other",
                      ]}
                    />
                    <AiTeamDropDown
                      text="Technical Function"
                      width="12.80rem"
                      options={[
                        "Analytics",
                        "Analytics Blockchain",
                        "Business Intelligence",
                        "Security Analytics",
                        "CRM",
                        "ERP",
                        "Accounting",
                        "Operations",
                        "Marketing Automation",
                        "Computational Biology",
                        "Data Engineering",
                        "Data Management",
                        "Data Visualization",
                        "Design, Devops",
                        "Enterprise Performance Management",
                        "Gaming analytics",
                        "Internet of things",
                        "Marketing and Web Analytics",
                        "Mobile Apps",
                        "Ontology and Semantic Technology",
                        "Quality Assurance",
                        "Robotics",
                        "Robotic Process Automation",
                        "Security Analytics",
                        "Software and Web Development",
                        "Speech and Voice Analytics",
                        "Other",
                      ]}
                    />
                    <AiTeamDropDown
                      text="Specialization"
                      width="12.80rem"
                      options={[
                        "Finance",
                        "Financial Planning & Analysis",
                        "Consumer Experience",
                        "Strategic Business Planning",
                        "Go-to-Market & Market Growth Strategy",
                        "Biology Health Care and Medicine",
                        "Brand and Marketing Strategy",
                        "Business Analysis",
                        "Business Process Redesign",
                        "Change Management",
                        "Chemistry",
                        "Consumer Experience",
                        "Customer Analytics",
                        "Due Diligence",
                        "Engineering and design",
                        "Exploration and production",
                        "General Management Consulting",
                        "Human Ressources",
                        "Managed Markets",
                        "Market Research",
                        "Marketing",
                        "Media and Advertising",
                        "Mergers and Acquisitions Strategy",
                        "Physical Science",
                        "Pricing and Actuarial",
                        "Project Management",
                        "R&D",
                        "Risk and Compliance",
                        "Sales",
                        "Security and Operations",
                        "Social Media",
                        "Social Sciences",
                        "Startegic Business Planning",
                        "Supply Chain and Logistics",
                        "Technical Writing",
                        "Voice of Customer Research",
                        "Other",
                      ]}
                    />
                    <AiTeamDropDown text="Industry" width="12.80rem" />
                  </div>
                </div>
                <div className="flex items-center gap-2 mt-4">
                  <button className="w-[9.5rem] h-[2.5rem] rounded-[8px] text-[0.90rem] text-white font-[500] bg-[#942A27]">
                    Show 32 Results
                  </button>
                  <button className="w-[4.9rem] h-[2.5rem] rounded-[8px] border-[#E5E7EB] border-[1px] text-[#1F2A37] text-[0.90rem]">
                    Reset
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
      <section className="bg-[#f9fafb] w-full pt-6 px-7 pb-8">
        <div className="flex items-center gap-3">
          <p className="text-[1rem] font-bold text-[#6B7280]">
            All Users: <span className="text-[#111928]">1,356,546</span>
          </p>
          <p className="text-[1rem] font-bold text-[#6B7280]">
            Teams: <span className="text-[#111928]">884</span>
          </p>
        </div>
        <div className="flex items-center flex-wrap justify-center gap-5 mt-6">
          <AITeamCard
            teamimg={TeamImg}
            teamname="Team Name"
            text="Lorem ipsum dolor sit amet consectetur. Mauris risus rutrum diam at."
            projectname="none"
          />
          <AITeamCard
            teamimg={TeamImgOne}
            teamname="Team Name"
            text="Lorem ipsum dolor sit amet consectetur. Mauris risus rutrum diam at."
            projectname="none"
          />
          <AITeamCard
            teamimg={TeamImgTwo}
            teamname="Team Name"
            text="Lorem ipsum dolor sit amet consectetur. Mauris risus rutrum diam at."
            projectname="none"
          />
          <AITeamCard
            teamimg={TeamImgThree}
            teamname="Team Name"
            text="Lorem ipsum dolor sit amet consectetur. Mauris risus rutrum diam at."
            projectname="none"
          />
          <AITeamCard
            teamimg={TeamImgOne}
            teamname="Team Name"
            text="Lorem ipsum dolor sit amet consectetur. Mauris risus rutrum diam at."
            projectname="none"
          />
          <AITeamCard
            teamimg={TeamImg}
            teamname="Team Name"
            text="Lorem ipsum dolor sit amet consectetur. Mauris risus rutrum diam at."
            projectname="none"
          />
          <AITeamCard
            teamimg={TeamImgTwo}
            teamname="Team Name"
            text="Lorem ipsum dolor sit amet consectetur. Mauris risus rutrum diam at."
            projectname="none"
          />
          <AITeamCard
            teamimg={TeamImg}
            teamname="Team Name"
            text="Lorem ipsum dolor sit amet consectetur. Mauris risus rutrum diam at."
            projectname="none"
          />
          <AITeamCard
            teamimg={TeamImgTwo}
            teamname="Team Name"
            text="Lorem ipsum dolor sit amet consectetur. Mauris risus rutrum diam at."
            projectname="none"
          />
          <AITeamCard
            teamimg={TeamImgThree}
            teamname="Team Name"
            text="Lorem ipsum dolor sit amet consectetur. Mauris risus rutrum diam at."
            projectname="none"
          />
          <AITeamCard
            teamimg={TeamImgOne}
            teamname="Team Name"
            text="Lorem ipsum dolor sit amet consectetur. Mauris risus rutrum diam at."
            projectname="none"
          />
          <AITeamCard
            teamimg={TeamImg}
            teamname="Team Name"
            text="Lorem ipsum dolor sit amet consectetur. Mauris risus rutrum diam at."
            projectname="none"
          />
          <AITeamCard
            teamimg={TeamImgTwo}
            teamname="Team Name"
            text="Lorem ipsum dolor sit amet consectetur. Mauris risus rutrum diam at."
            projectname="none"
          />
          <AITeamCard
            teamimg={TeamImg}
            teamname="Team Name"
            text="Lorem ipsum dolor sit amet consectetur. Mauris risus rutrum diam at."
            projectname="none"
          />
          <AITeamCard
            teamimg={TeamImgTwo}
            teamname="Team Name"
            text="Lorem ipsum dolor sit amet consectetur. Mauris risus rutrum diam at."
            projectname="none"
          />
          <AITeamCard
            teamimg={TeamImg}
            teamname="Team Name"
            text="Lorem ipsum dolor sit amet consectetur. Mauris risus rutrum diam at."
            projectname="none"
          />
        </div>
        <div className="flex items-center justify-center mt-8">
          <button className="w-[6.9rem] py-2 border-[1px] border-[#E5E7EB] rounded-[8px] text-[0.95rem] font-[500] text-[#1F2A37]">
            Load more
          </button>
        </div>
      </section>
    </DashboardLayout>
  );
}
